import ReducerConstants from "../../config/ReduxConstant";
import { IActionProps } from "./feedbackData";

const INITIAL_STATE: Array<Object> = []

export const feedbackSeedData = (state = INITIAL_STATE, action: IActionProps) => {
  switch (action.type) {
    case ReducerConstants.SET_FEEDBACK_SEED_DATA:
      return action.payload || []
    default:
      return state
  }
}
